import { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { isEmpty } from "lodash";
import { ReactComponent as CalendarIcon } from "../../assets/calendar24x24.svg";
import { ReactComponent as ArrowRight } from "../../assets/submit.svg";
import {
  numberOfEmployeesRangeOptions,
  turnoverRangeOptions,
  totalAssetsRangeOptions,
  balanceSheetRangeOptions
} from "../../data/data";
import {
  labelOf,
  labelOfCapitalization,
  labelOfCompanyType,
  labelOfIndustry,
  labelOfSize,
  labelOfFramework,
  labelOfLawType
} from "../../util/labelOf";
import { downloadDocument } from "../../store/documents/actions";
// Import the styles for the pdf viewer
// import "@react-pdf-viewer/core/lib/styles/index.css";

// date fns
//import formatDistanceToNow from "date-fns/formatDistanceToNow";
import { format, parseISO } from "date-fns";
// import "react-pdf/dist/esm/Page/TextLayer.css";
import "react-pdf/dist/esm/Page/AnnotationLayer.css";
import "./lawDetails.css";
//pdf related imports
// import { Viewer, Worker } from "@react-pdf-viewer/core";
import { pdfjs, Document, Page } from "react-pdf";
import { Button } from "antd";
pdfjs.GlobalWorkerOptions.workerSrc = `//unpkg.com/pdfjs-dist@${pdfjs.version}/build/pdf.worker.min.mjs`;

const LawDetails = ({ law = {}, setSelectedDocument, deleted, setDeleted }) => {
  const ArrowLeft = <ArrowRight style={{transform: "rotate(180deg)"}}/>

  const dispatchito = useDispatch();
  const user = useSelector(state => state.user);
  const organizations = useSelector(state => state.organizations.organizations);
  const lawId = law?._id;
  const doc = useSelector(state => state.documents?.laws?.[lawId] ?? {});
  const [linkSource, setLinkSource] = useState("");

  const [numPages, setNumPages] = useState();
  const [pageNumber, setPageNumber] = useState(1);

  function onDocumentLoadSuccess(pdf) {
    setNumPages(pdf?.numPages);
  }

  useEffect(() => {
    if (!deleted) {
      dispatchito(
        downloadDocument({
          docId: doc?.doc_id,
          user,
          callback: (url = "") => {
            setLinkSource(url);
          }
        })
      );
    }
    setDeleted(false);
  }, []);

  // console.debug("isRunningOnLocalHost: ", isRunningOnLocalHost());

  // console.debug("law info", law ?? "");
  if (!law) {
    return null;
  } else {
    return (
      <>
        <div className="law-details">
          <div id="lawDetailsHeader">
            <h4>{law.title}</h4>
            <div id="calendarArea">
              <CalendarIcon />
              <strong>In Force Date: </strong>
              {format(parseISO(law?.inForceDate), "d MMM yyyy")}
            </div>
          </div>

          <div
            style={{
              width: "100%",
              height: "100%",
              border: "0.063rem #E5E5E5 solid"
            }}
            id="lawDetailsLine"
          ></div>

          {law.type && (
            <div style={{ textAlign: "left", fontSize: "0.875rem" }}>
              <strong>Law Type: </strong>
              {labelOfLawType(law.type)}
            </div>
          )}
          <div style={{ textAlign: "left", fontSize: "0.875rem" }}>
            <strong>Is for both listed and not listed companies: </strong>
            {law?.isBothListedAndNotListed
              ? "Yes"
              : law?.isListed
              ? "No, only listed"
              : "No, only not listed"}
          </div>
          {/* <div>
        <strong>Due Date: </strong>
        {format(new Date(law.dueDate), "PP")}
      </div> */}
          {law?.applySpecificallyToOrgs && (
            <div style={{ textAlign: "left", fontSize: "0.875rem" }}>
              <strong>Applies To Specific Organizations: </strong>
              {!isEmpty(law.organizations)
                ? law.organizations.map((value, index, arr) => {
                    let punctuation = index + 1 === arr.length ? "." : ", ";
                    const org = organizations?.find(org => org._id === value);
                    return org?.customerName + punctuation;
                  })
                : ""}
            </div>
          )}
          {!law?.applySpecificallyToOrgs && (
            <div style={{ textAlign: "left", fontSize: "0.875rem" }}>
              <strong>Applies To All Industries: </strong>
              {law.applyToAll ? "Yes" : "No"}
              {!law.applyToAll && (
                <>
                  <div style={{ marginLeft: "0.625rem" }}>
                    <strong>Applies to: </strong>
                  </div>
                  {law.size[0] !== "" && (
                    <div style={{ marginLeft: "0.625rem" }}>
                      <strong>Company Size: </strong>
                      {law.size &&
                        law.size.length &&
                        law.size[0] !== "" &&
                        law.size.map((value, index, arr) => {
                          let punctuation =
                            index + 1 === arr.length ? "." : ", ";
                          return labelOfSize(value) + punctuation;
                        })}
                    </div>
                  )}
                  {law?.industries &&
                    law.industries.length &&
                    law.industries[0] !== "" && (
                      <div style={{ marginLeft: "0.625rem" }}>
                        <strong>Industries: </strong>
                        {law.industries.map((value, index, arr) => {
                          let punctuation =
                            index + 1 === arr.length ? "." : ", ";
                          return labelOfIndustry(value) + punctuation;
                        })}
                        {/* <ul style={{ listStyle: "none", margin: 0, padding: 0 }}>
                      {law?.industries.map(industry => (
                        <li key={industry}>
                          {" "}
                          {industryOptions.find(item => item.value === industry)
                            ?.label ?? industry}
                        </li>
                      ))}
                    </ul> */}
                      </div>
                    )}
                  {law?.companyTypes &&
                    law?.companyTypes.length &&
                    law.companyTypes[0] !== "" && (
                      <div style={{ marginLeft: "0.625rem" }}>
                        <strong>Company Types: </strong>

                        {law.companyTypes.map((value, index, arr) => {
                          let punctuation =
                            index + 1 === arr.length ? "." : ", ";
                          return labelOfCompanyType(value) + punctuation;
                        })}
                      </div>
                    )}
                  {law?.capitalization &&
                    law.capitalization.length &&
                    law.capitalization[0] !== "" && (
                      <div style={{ marginLeft: "0.625rem" }}>
                        <strong>Capitalization Range: </strong>

                        {law.capitalization.map((value, index, arr) => {
                          let punctuation =
                            index + 1 === arr.length ? "." : ", ";
                          let label = labelOfCapitalization(value);
                          return (label === "" ? value : label) + punctuation;
                        })}
                      </div>
                    )}
                  {law?.numberOfEmployees &&
                    law?.numberOfEmployees.length &&
                    law.numberOfEmployees[0] !== "" && (
                      <div style={{ marginLeft: "0.625rem" }}>
                        <strong>Number of Employees Range: </strong>

                        {law.numberOfEmployees.map((value, index, arr) => {
                          let punctuation =
                            index + 1 === arr.length ? "." : " or ";
                          return (
                            labelOf(numberOfEmployeesRangeOptions, value) +
                            punctuation
                          );
                        })}
                      </div>
                    )}
                  {law?.turnover &&
                    law?.turnover.length &&
                    law.turnover[0] !== "" && (
                      <div style={{ marginLeft: "0.625rem" }}>
                        <strong>Turnover Range: </strong>

                        {law.turnover.map((value, index, arr) => {
                          let punctuation =
                            index + 1 === arr.length ? "." : " or ";
                          return (
                            labelOf(turnoverRangeOptions, value) + punctuation
                          );
                        })}
                      </div>
                    )}
                  {law?.totalAssets &&
                    law?.totalAssets.length &&
                    law.totalAssets[0] !== "" && (
                      <div style={{ marginLeft: "0.625rem" }}>
                        <strong>Total Assets Range: </strong>

                        {law.totalAssets.map((value, index, arr) => {
                          let punctuation =
                            index + 1 === arr.length ? "." : " or ";
                          return (
                            labelOf(totalAssetsRangeOptions, value) +
                            punctuation
                          );
                        })}
                      </div>
                    )}
                  {law?.balanceSheet &&
                    law?.balanceSheet.length &&
                    law.balanceSheet[0] !== "" && (
                      <div style={{ marginLeft: "0.625rem" }}>
                        <strong>Balance Sheet Range: </strong>

                        {law.balanceSheet.map((value, index, arr) => {
                          let punctuation =
                            index + 1 === arr.length ? "." : " or ";
                          return (
                            labelOf(balanceSheetRangeOptions, value) +
                            punctuation
                          );
                        })}
                      </div>
                    )}
                </>
              )}
            </div>
          )}
          <div style={{ textAlign: "left", fontSize: "0.875rem" }}>---</div>
          <div style={{ textAlign: "left", fontSize: "0.875rem" }}>
            <strong>Main Category: </strong>
            {labelOfFramework(law.mainCategory)}
          </div>
        </div>
        <div id="pdf-area" style={{ position: "relative" }}>
          {numPages && <div
            id="pdf-pagination"
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center"
            }}
          >
            <Button
              id="pdf-page-previous"
              shape="circle" 
              type="link"
              icon={ArrowLeft}
              className="pdf-page-button"
              onClick={() => {if (pageNumber>1) setPageNumber(pageNumber - 1)}}
              style={{ visibility: pageNumber === 1 ? "hidden" : "visible" }}
            />
              Page {numPages ? pageNumber : "-"} of {numPages || "-"}
            <Button
              id="pdf-page-next"
              shape="circle" 
              type="link"
              icon={<ArrowRight />}
              className="pdf-page-button"
              onClick={() => {if (pageNumber<numPages) setPageNumber(pageNumber + 1)}}
              style={{
                visibility: pageNumber === numPages ? "hidden" : "visible"
              }}
            />
          </div>}
          <div
            id="pdf-wrapper"
            style={{
              // border: "1px solid red",
              width: "min-content",
              margin: "auto",
              boxShadow: "0rem 0.25rem 1.75rem rgba(217.94, 198.4, 245.44",
            }}
          >
            <Document file={linkSource} onLoadSuccess={onDocumentLoadSuccess} noData={<></>} loading={<></>}>
              <Page pageNumber={pageNumber} scale={1.5} />
            </Document>
          </div>
        </div>
      </>
    );
  }
};

export default LawDetails;
